import { WhitePage } from "../pages/util";
import { useConfig } from "../state";
import "./Filter.css";

const results = [
  {
    gps: "5.37388,52.16112",
    bestemming: "Wonen",
  },
  {
    gps: "5.39284,52.15436",
    bestemming: "Agrarisch",
  },
  {
    gps: "5.88064,51.87476",
    bestemming: "Bedrijvenspecifiek",
  },
  {
    gps: "5.94555,51.89390",
    bestemming: "Landelijk",
  },
  {
    gps: "5.83716,51.82195",
    bestemming: "Industrie",
  },
];
const Results = () => {
  const config = useConfig();
  return (
    <div className="form-section">
      <h2 className="text-xl">Resultaten (5 fictieve kavels)</h2>
      <div className="form-row flex-wrap gap-1">
        {results.map((result, index) => (
          <div key={index} className="min-w-13">
            <img
              src={`${config.referenceUrl}/api/image/cadastre?c=${result.gps}&width=280&height=160`}
              srcSet={`${config.referenceUrl}/api/image/cadastre?c=${result.gps}&width=280&height=160 1x, ${config.referenceUrl}/api/image/cadastre?c=${result.gps}&width=560&height=320 2x`}
              className="w-full border-2 border-solid border-gray-300 rounded-lg"
            />
            <p>
              <strong>Kavel {index + 1}:</strong> {1500 - 300 * index} m² – Gemeente X – Bestemming:{" "}
              {result.bestemming}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
export const Filter = () => (
  <WhitePage>
    <div className="filter">
      <h1 className="text-2xl">Zoek ontwikkellocatie</h1>

      <form>
        <div className="form-section">
          <h2 className="text-xl">1. Algemene Gegevens</h2>
          <div className="form-row">
            <div>
              <label>Kadastrale aanduiding</label>
              <input type="text" name="kadastraal" />
            </div>
            <div>
              <label>Oppervlakte (min m²)</label>
              <input type="number" name="opp_min" />
            </div>
            <div>
              <label>Oppervlakte (max m²)</label>
              <input type="number" name="opp_max" />
            </div>
            <div>
              <label>Bundel kadastrale kavels</label>
              <select>
                <option>--</option>
                <option>Ja</option>
                <option>Nee</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h2 className="text-xl">2. Juridisch & Bestemmingsplan</h2>
          <div className="form-row">
            <div>
              <label>Bestemmingstype</label>
              <select>
                <option>-- Selecteer --</option>
                <option>Wonen</option>
                <option>Bedrijf</option>
              </select>
            </div>
            <div>
              <label>Publiekrechtelijke beperkingen</label>
              <select>
                <option>--</option>
                <option>Geen</option>
                <option>Aanwezig</option>
              </select>
            </div>
            <div>
              <label>Erfpacht</label>
              <select>
                <option>--</option>
                <option>Ja</option>
                <option>Nee</option>
              </select>
            </div>
            <div>
              <label>Recht van overpad</label>
              <select>
                <option>--</option>
                <option>Ja</option>
                <option>Nee</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h2 className="text-xl">3. Omgevingsfactoren</h2>
          <div className="form-row">
            <div>
              <label>Bereikbaarheid OV (max m)</label>
              <input type="number" name="ov_max" />
            </div>
            <div>
              <label>Voorzieningen binnen straal (km)</label>
              <select>
                <option>-- Selecteer --</option>
                <option>Winkelcentrum</option>
                <option>School</option>
                <option>Sportclub</option>
                <option>Recreatie</option>
              </select>
            </div>
            <div>
              <label>Veiligheidsscore</label>
              <select>
                <option>--</option>
                <option>Hoog</option>
                <option>Gemiddeld</option>
                <option>Laag</option>
              </select>
            </div>
            <div>
              <label>Wijkprofiel</label>
              <select>
                <option>--</option>
                <option>Gezin</option>
                <option>Ouderen</option>
                <option>Jongeren</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h2 className="text-xl">4. Milieu, Bodem & Natuur</h2>
          <div className="form-row">
            <div>
              <label>Bodemkwaliteit</label>
              <select>
                <option>--</option>
                <option>Onverdacht</option>
                <option>Verdacht</option>
              </select>
            </div>
            <div>
              <label>Grondsoort</label>
              <select>
                <option>--</option>
                <option>Zand</option>
                <option>Klei</option>
                <option>Loss</option>
                <option>Veen</option>
              </select>
            </div>
            <div>
              <label>Explosieven (trefkans)</label>
              <select>
                <option>--</option>
                <option>1 - Zeer laag</option>
                <option>2 - Laag</option>
                <option>3 - Middel</option>
                <option>4 - Hoog</option>
                <option>5 - Zeer hoog</option>
              </select>
            </div>
            <div>
              <label>Luchtkwaliteit</label>
              <select>
                <option>--</option>
                <option>Goed</option>
                <option>Matig</option>
                <option>Slecht</option>
              </select>
            </div>
            <div>
              <label>Geluidsbelasting</label>
              <select>
                <option>--</option>
                <option>Laag</option>
                <option>Norm</option>
                <option>Hoog</option>
              </select>
            </div>
            <div>
              <label>Beschermde flora/fauna</label>
              <select>
                <option>--</option>
                <option>Nee</option>
                <option>Ja</option>
              </select>
            </div>
            <div>
              <label>Archeologische waarde</label>
              <select>
                <option>--</option>
                <option>1 - Zeer laag</option>
                <option>2 - Laag</option>
                <option>3 - Middel</option>
                <option>4 - Hoog</option>
                <option>5 - Zeer hoog</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h2 className="text-xl">5. Markt & Ontwikkelpotentie</h2>
          <div className="form-row">
            <div>
              <label>Woningvorm mogelijk</label>
              <select>
                <option>--</option>
                <option>Vrijstaand</option>
                <option>Rijwoning</option>
              </select>
            </div>
            <div>
              <label>Marktpotentie</label>
              <select>
                <option>--</option>
                <option>Hoog</option>
                <option>Gemiddeld</option>
                <option>Laag</option>
              </select>
            </div>
            <div>
              <label>Nieuwbouw in omgeving</label>
              <select>
                <option>--</option>
                <option>Ja</option>
                <option>Nee</option>
              </select>
            </div>
            <div>
              <label>Draagvlak gemeente</label>
              <select>
                <option>--</option>
                <option>Goed</option>
                <option>Neutraal</option>
                <option>Beperkt</option>
              </select>
            </div>
          </div>
        </div>

        <button type="submit">🔍 Zoek kavels</button>
      </form>
      <Results />
    </div>
  </WhitePage>
);
